/* Ported from _deploy_baseline/_v3/v3.js by _th-v3-tools/port_assets.py. Edit the source there, then re-run the port. */
/* THUNDER HONEY v3 behaviours. Reveals, nav, menu, hero video, lazy media, lightbox, accordion, plan chooser, sticky CTA. */
(function () {
  var d = document, w = window, html = d.documentElement;
  var SV = (html.getAttribute('lang') || '').indexOf('sv') === 0; /* the Swedish pages: messages in Swedish */
  var CDN = (w.TH_V3 && w.TH_V3.cdn) || 'https://shop.thunderhoney.co/cdn/shop/t/92/assets/'; /* on Shopify: this theme's own asset folder */

  /* reveals */
  var io = ('IntersectionObserver' in w) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  d.querySelectorAll('[data-rise],[data-fade],[data-stagger],[data-in]').forEach(function (el) { io ? io.observe(el) : el.classList.add('is-in'); });
  html.classList.add('th-rv'); /* Shopify: tells th-v3-head the reveal observer runs, so html.th-js may keep reveals hidden */

  /* nav: glass after 10px; dark text on light heroless pages */
  var nav = d.querySelector('.nav');
  function onScroll() { html.classList.toggle('scrolled', w.scrollY > 10); }
  onScroll(); w.addEventListener('scroll', onScroll, { passive: true });

  /* hamburger */
  var burger = d.querySelector('.burger'), menu = d.querySelector('.menu');
  if (burger && menu) {
    burger.addEventListener('click', function () { html.classList.toggle('menu-open'); burger.setAttribute('aria-expanded', html.classList.contains('menu-open')); });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { html.classList.remove('menu-open'); }); });
  }

  /* hero video: CDN source picked by viewport, poster is the section background, fade in on first frame */
  var hv = d.getElementById('heroVid');
  if (hv) {
    var mobile = Math.min(w.innerWidth, w.screen.width) <= 768;
    var srcs = mobile ? [CDN + 'th-hero-eira-mobile.mp4'] : [CDN + 'th-hero-eira-1080.mp4'];
    (hv.dataset.fallback ? srcs.concat([hv.dataset.fallback]) : srcs).forEach(function (u) { var s = d.createElement('source'); s.src = u; s.type = 'video/mp4'; hv.appendChild(s); });
    var hero = hv.closest('.hero');
    if (hero) hero.style.backgroundImage = 'url(' + CDN + (mobile ? 'th-hero-eira-mobile-poster.jpg' : 'th-hero-eira-1080-poster.jpg') + ')';
    hv.load();
    function show() { hv.classList.add('is-live'); }
    hv.addEventListener('playing', show, { once: true });
    hv.addEventListener('timeupdate', function f() { if (hv.currentTime > 0.05) { show(); hv.removeEventListener('timeupdate', f); } });
    function kick() { try { var p = hv.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
    kick(); hv.addEventListener('loadeddata', kick);
    ['touchstart', 'click'].forEach(function (ev) { w.addEventListener(ev, function () { if (hv.paused) kick(); }, { once: true, passive: true }); });
    d.addEventListener('visibilitychange', function () { if (!d.hidden && hv.paused) kick(); });
  }

  /* lazy videos: nothing downloads until the section is near, and never before the hero is buffered */
  var lazies = [].slice.call(d.querySelectorAll('video[data-lazyvid]'));
  function goVid(v) {
    if (v.__lz) return; v.__lz = 1;
    if (v.dataset.poster) v.poster = v.dataset.poster;
    if (v.dataset.src && !v.querySelector('source') && !v.src) { var s = d.createElement('source'); s.src = v.dataset.src + (v.dataset.start ? '#t=' + v.dataset.start : ''); s.type = 'video/mp4'; v.appendChild(s); }
    clipWindow(v);
    v.preload = 'auto'; try { v.load(); } catch (e) {}
    if (v.hasAttribute('data-autoplay')) { try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
  }
  /* data-start / data-end on a video: only that window of the clip plays, even when the viewer scrubs with the controls */
  function clipWindow(v) {
    var a = parseFloat(v.dataset.start) || 0, b = parseFloat(v.dataset.end) || 0;
    if (v.__clip || (!a && !b)) return; v.__clip = 1;
    function fit() {
      try {
        if (a && v.currentTime < a - 0.05) v.currentTime = a;
        else if (b && v.currentTime >= b) { v.pause(); v.currentTime = a; var c = v.closest('[data-ugc]'); if (c) c.classList.remove('is-playing'); }
      } catch (e) {}
    }
    ['loadedmetadata', 'play', 'seeked', 'timeupdate'].forEach(function (ev) { v.addEventListener(ev, fit); });
  }
  function startLazy() {
    if (startLazy.done || !lazies.length) return; startLazy.done = 1;
    if (!io) { lazies.forEach(goVid); return; }
    var vio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { (e.target.__vs || []).forEach(goVid); vio.unobserve(e.target); } }); }, { rootMargin: '600px 0px' });
    var seen = [];
    lazies.forEach(function (v) { var t = v.closest('section') || v.parentElement || v; t.__vs = (t.__vs || []).concat([v]); if (seen.indexOf(t) < 0) { seen.push(t); vio.observe(t); } });
  }
  if (hv) {
    hv.addEventListener('progress', function f() { try { var b = hv.buffered; if (hv.duration && b.length && b.end(b.length - 1) >= hv.duration - 0.5) { hv.removeEventListener('progress', f); startLazy(); } } catch (e) {} });
    w.addEventListener('scroll', function s() { if (w.scrollY > 200) { w.removeEventListener('scroll', s); startLazy(); } }, { passive: true });
    setTimeout(startLazy, 8000);
  } else { startLazy(); }

  /* click-to-play UGC: poster shows, tap plays with sound */
  d.querySelectorAll('[data-ugc]').forEach(function (card) {
    var cv = card.querySelector('video');
    if (cv) cv.addEventListener('ended', function () { card.classList.remove('is-playing'); });
    card.addEventListener('keydown', function (e) { if (e.target === card && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); card.click(); } });
    card.addEventListener('click', function () {
      var v = card.querySelector('video'); if (!v) return;
      if (v.paused) { d.querySelectorAll('[data-ugc] video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('[data-ugc]').classList.remove('is-playing'); } }); v.muted = false; v.controls = true; goVid(v); v.play().catch(function () {}); card.classList.add('is-playing'); }
      else { v.pause(); card.classList.remove('is-playing'); }
    });
  });

  /* small video cards (data-pop): a tap opens the clip in a pop-up player, with sound where the clip has one.
     Markup: <button type="button" data-pop data-src="CDN mp4" aria-label="Play video: ..."><img ...></button>.
     data-start / data-end play only that window of the clip (as on the data-ugc cards); data-silent marks a clip with no
     sound track, so the player hides its volume control. Nothing downloads before the tap; closing stops the download. */
  var pops = d.querySelectorAll('[data-pop]');
  if (pops.length) {
    var vlb = d.createElement('div');
    vlb.className = 'vlb'; vlb.hidden = true;
    vlb.setAttribute('role', 'dialog'); vlb.setAttribute('aria-modal', 'true'); vlb.setAttribute('aria-label', 'Video');
    vlb.innerHTML = '<video class="vlb__v" controls playsinline preload="none"></video><button type="button" class="vlb__x" aria-label="' + (SV ? 'Stäng filmen' : 'Close video') + '">&times;</button>';
    d.body.appendChild(vlb);
    var vv = vlb.querySelector('video'), vx = vlb.querySelector('.vlb__x'), vFrom = null, vA = 0, vB = 0, vT = 0;
    function vFit() {
      try {
        if (vA && vv.currentTime < vA - 0.05) vv.currentTime = vA;
        else if (vB && vv.currentTime >= vB) { vv.pause(); vv.currentTime = vA; }
      } catch (e) {}
    }
    ['loadedmetadata', 'play', 'seeked', 'timeupdate'].forEach(function (ev) { vv.addEventListener(ev, vFit); });
    function vOpen(card) {
      clearTimeout(vT); vFrom = card;
      vA = parseFloat(card.getAttribute('data-start')) || 0; vB = parseFloat(card.getAttribute('data-end')) || 0;
      if (card.hasAttribute('data-silent')) vv.setAttribute('data-silent', ''); else vv.removeAttribute('data-silent');
      vv.src = card.getAttribute('data-src') + (vA ? '#t=' + vA : '');
      vv.muted = false; vv.preload = 'auto';
      vlb.setAttribute('aria-label', (card.getAttribute('aria-label') || 'Video').replace(/^Play video: /, 'Video: ').replace(/^Spela film: /, 'Film: '));
      vlb.hidden = false; html.classList.add('vlb-open');
      void vlb.offsetWidth; vlb.classList.add('is-on');
      var p = vv.play(); if (p && p.catch) p.catch(function () {});
      try { vx.focus({ preventScroll: true }); } catch (e) { vx.focus(); }
    }
    function vClose() {
      if (vlb.hidden) return;
      vv.pause(); vlb.classList.remove('is-on'); html.classList.remove('vlb-open');
      clearTimeout(vT);
      vT = setTimeout(function () { vlb.hidden = true; vv.removeAttribute('src'); try { vv.load(); } catch (e) {} }, 320);
      if (vFrom) { try { vFrom.focus({ preventScroll: true }); } catch (e) { vFrom.focus(); } }
    }
    pops.forEach(function (c) { c.addEventListener('click', function (e) { e.preventDefault(); vOpen(c); }); });
    vx.addEventListener('click', vClose);
    vlb.addEventListener('click', function (e) { if (e.target === vlb) vClose(); });
    d.addEventListener('keydown', function (e) {
      if (vlb.hidden) return;
      if (e.key === 'Escape') vClose();
      else if (e.key === 'Tab') { e.preventDefault(); (d.activeElement === vx ? vv : vx).focus(); }
    });
  }

  /* product gallery (data-gal): radios switch the images without script; this adds the arrow buttons
     (data-gal-prev / data-gal-next, shown once .is-gal is set) and a sideways swipe on [data-gal-swipe] */
  d.querySelectorAll('[data-gal]').forEach(function (g) {
    var rs = [].slice.call(g.querySelectorAll('input[type=radio]'));
    if (rs.length < 2) return;
    g.classList.add('is-gal');
    function at() { for (var i = 0; i < rs.length; i++) if (rs[i].checked) return i; return 0; }
    function go(i) { var r = rs[(i + rs.length) % rs.length]; r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    g.querySelectorAll('[data-gal-prev]').forEach(function (b) { b.addEventListener('click', function () { go(at() - 1); }); });
    g.querySelectorAll('[data-gal-next]').forEach(function (b) { b.addEventListener('click', function () { go(at() + 1); }); });
    var sw = g.querySelector('[data-gal-swipe]') || g, x0 = null, y0 = 0;
    sw.addEventListener('touchstart', function (e) { if (e.touches.length !== 1) { x0 = null; return; } x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    sw.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) go(at() + (dx < 0 ? 1 : -1));
    }, { passive: true });
  });

  /* talking-head player: tap for sound, pause when scrolled away, resume on return */
  d.querySelectorAll('[data-player]').forEach(function (fig) {
    var v = fig.querySelector('video'), btn = fig.querySelector('[data-sound]'); if (!v) return;
    if (btn) btn.addEventListener('click', function (e) {
      e.stopPropagation(); goVid(v);
      if (v.muted) { v.muted = false; try { v.currentTime = 0; } catch (x) {} btn.textContent = SV ? 'Stäng av ljudet' : 'Mute'; btn.setAttribute('aria-pressed', 'true'); }
      else { v.muted = true; btn.textContent = SV ? 'Tryck för ljud' : 'Tap for sound'; btn.setAttribute('aria-pressed', 'false'); }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
    if (io) new IntersectionObserver(function (es) { es.forEach(function (e) {
      if (!v.__lz) return;
      if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
    }); }, { threshold: 0.25 }).observe(fig);
  });

  /* lightbox for gallery images */
  var lb = d.getElementById('lb');
  if (lb) {
    var lbi = lb.querySelector('img');
    d.querySelectorAll('[data-zoom]').forEach(function (el) {
      el.addEventListener('click', function () { var src = el.getAttribute('data-zoom') || el.currentSrc || el.src; if (!src) return; lbi.src = src; lbi.alt = el.alt || ''; lb.classList.add('on'); });
    });
    lb.addEventListener('click', function () { lb.classList.remove('on'); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') lb.classList.remove('on'); });
  }

  /* accordion (FAQ): <details> gets a smooth open */
  d.querySelectorAll('details[data-acc]').forEach(function (dt) {
    dt.addEventListener('toggle', function () { if (dt.open) d.querySelectorAll('details[data-acc]').forEach(function (o) { if (o !== dt) o.open = false; }); });
  });

  /* plan chooser: radio-like cards, updates price in CTA */
  var plans = d.querySelectorAll('[data-plan]');
  if (plans.length) {
    var cta = d.querySelector('[data-plan-cta]'), ctaPrice = d.querySelector('[data-plan-price]');
    function pick(p) { plans.forEach(function (o) { o.classList.toggle('is-on', o === p); o.setAttribute('aria-checked', o === p); }); if (ctaPrice) ctaPrice.textContent = p.dataset.price || ''; if (cta && p.dataset.href) cta.href = p.dataset.href; }
    var arr = [].slice.call(plans);
    plans.forEach(function (p, i) {
      p.addEventListener('click', function () { pick(p); });
      p.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(p); }
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); var n = arr[(i + 1) % arr.length]; pick(n); n.focus(); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); var q = arr[(i - 1 + arr.length) % arr.length]; pick(q); q.focus(); }
      });
    });
    pick(d.querySelector('[data-plan].is-on') || plans[0]);
  }

  /* sticky mobile CTA appears after the hero */
  var sticky = d.querySelector('.sticky');
  if (sticky) { function st() { sticky.classList.toggle('on', w.scrollY > (w.innerHeight * 0.9)); } st(); w.addEventListener('scroll', st, { passive: true }); }

  /* energy graph: draw the lines when in view */
  d.querySelectorAll('[data-draw]').forEach(function (svg) {
    svg.querySelectorAll('path,polyline,line').forEach(function (p) { try { var L = p.getTotalLength(); p.style.strokeDasharray = L; p.style.strokeDashoffset = L; } catch (e) {} });
    if (io) { var gio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { svg.classList.add('is-drawn'); gio.unobserve(svg); } }); }, { threshold: 0.35 }); gio.observe(svg); } else svg.classList.add('is-drawn');
  });

  /* newsletter: Klaviyo client subscribe, list VdukM9 */
  d.querySelectorAll('form[data-news]').forEach(function (form) {
    var msg = form.parentElement.querySelector('[data-news-msg]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type=email]'), email = (input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { if (msg) { msg.hidden = false; msg.textContent = SV ? 'Skriv en giltig e-postadress.' : 'Please enter a valid email address.'; } input.focus(); return; }
      var btn = form.querySelector('button'); btn.disabled = true;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UKLDCx', { method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'thunderhoney.co footer', profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: 'VdukM9' } } } } }) })
      .then(function (r) { if (!r.ok && r.status !== 202) throw new Error(r.status); form.hidden = true; if (msg) { msg.hidden = false; msg.textContent = SV ? 'Tack! Bekräfta i din inkorg, sedan kommer din kod på 10 %.' : 'Thank you. Check your inbox to confirm, your 10% code follows.'; } })
      .catch(function () { btn.disabled = false; if (msg) { msg.hidden = false; msg.textContent = SV ? 'Något gick fel. Försök igen, eller skriv till support@thunderhoney.co.' : 'Something went wrong. Please try again, or write to support@thunderhoney.co.'; } });
    });
  });

  /* YouTube click-to-load */
  d.querySelectorAll('.ytc[data-yt]').forEach(function (c) {
    c.addEventListener('click', function () {
      var id = c.dataset.yt; var f = d.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0'; f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true; f.title = c.getAttribute('aria-label') || 'Video';
      c.innerHTML = ''; c.appendChild(f); c.classList.add('is-loaded');
    }, { once: true });
  });
})();
